import React, { useEffect, useState } from "react";
import axios from "axios";
import MaintenanceFase from "./ShowMaintaince";
import { useSelector } from "react-redux";

const MaintenanceWrapper = ({ children, moduleName, }) => {
    const maintenanceData = useSelector(state => state.maintenance);
    return maintenanceData?.data?.status == "down" ? <MaintenanceFase moduleName={moduleName} /> : children;
};

export default MaintenanceWrapper;
